"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNDEFINED_VERSION = void 0;
exports.UNDEFINED_VERSION = 'undefined';
//# sourceMappingURL=constants.js.map